import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            All Product Categories
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Click any category to browse verified CSSBuy Spreadsheet listings on kaspreadsheet.com
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4" data-product-shop="">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 hover:border-primary-300 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-primary-600 text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 mb-1 whitespace-nowrap">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{cat.description}</p>
              <div className="mt-3 flex items-center gap-1 text-primary-600 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                <span>Browse</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}